import {Component, Input, Output} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material';
import {AuthProcessService, AuthProvider} from '../../services/auth-process.service';

export enum Theme {
  DEFAULT = 'default',
  CLASSIC = 'classic',
  STROKED = 'stroked',
  FAB = 'fab',
  MINI_FAB = 'mini-fab',
  RAISED = 'raised',
}

export enum Layout {
  ROW = 'row',
  COLUMN = 'column'
}

@Component({
  selector: 'ngx-auth-firebaseui-providers',
  template: `
    <div [ngSwitch]="theme">

      <!--default icon buttons-->
      <div *ngSwitchDefault
           [fxLayout]="layout"
           fxLayout.xs="column"
           [fxLayoutAlign]="layout == 'row' ? 'space-around center' : 'stretch'">
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Google)"
                mat-button
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Google)">
          <mat-icon svgIcon="google-colored"></mat-icon>
          Google
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Facebook)"
                mat-button
                class="facebook-filled"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Facebook)">
          <mat-icon svgIcon="facebook"></mat-icon>
          Facebook
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Twitter)"
                mat-button
                class="twitter-filled"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Twitter)">
          <mat-icon svgIcon="twitter"></mat-icon>
          Twitter
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Github)"
                mat-button
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Github)">
          <mat-icon svgIcon="github"></mat-icon>
          GitHub
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Microsoft)"
                mat-button
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Microsoft)">
          <mat-icon svgIcon="microsoft"></mat-icon>
          Microsoft
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Yahoo)"
                mat-button
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Yahoo)">
          <mat-icon svgIcon="yahoo"></mat-icon>
          Yahoo
        </button>
      </div>

      <!--classic-->
      <div *ngSwitchCase="themes.CLASSIC"
           class="buttons-classic"
           [fxLayout]="layout"
           fxLayout.xs="column"
           [fxLayoutAlign]="layout == 'row' ? 'space-around center' : 'stretch'">
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Google)"
                mat-button
                class="google-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Google)">
          Google
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Facebook)"
                mat-button
                class="facebook-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Facebook)">
          Facebook
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Twitter)"
                mat-button
                class="twitter-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Twitter)">
          Twitter
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Github)"
                mat-button
                class="github-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Github)">
          GitHub
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Microsoft)"
                mat-button
                class="microsoft-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Microsoft)">
          Microsoft
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Yahoo)"
                mat-button
                class="yahoo-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Yahoo)">
          Yahoo
        </button>
      </div>

      <!--stroked-->
      <div *ngSwitchCase="themes.STROKED"
           class="buttons-classic"
           [fxLayout]="layout"
           fxLayout.xs="column"
           [fxLayoutAlign]="layout == 'row' ? 'space-around center' : 'stretch'">
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Google)"
                mat-stroked-button
                class="google-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Google)">
          Google
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Facebook)"
                mat-stroked-button
                class="facebook-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Facebook)">
          Facebook
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Twitter)"
                mat-stroked-button
                class="twitter-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Twitter)">
          Twitter
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Github)"
                mat-stroked-button
                class="github-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Github)">
          GitHub
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Microsoft)"
                mat-stroked-button
                class="microsoft-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Microsoft)">
          Microsoft
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Yahoo)"
                mat-stroked-button
                class="yahoo-classic"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Yahoo)">
          Yahoo
        </button>
      </div>

      <!--raised-->
      <div *ngSwitchCase="themes.RAISED"
           class="buttons-raised"
           [fxLayout]="layout"
           fxLayout.xs="column"
           [fxLayoutAlign]="layout == 'row' ? 'space-around center' : 'stretch'">
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Google)"
                mat-raised-button
                class="google-raised"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Google)">
          Google
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Facebook)"
                mat-raised-button
                class="facebook-raised"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Facebook)">
          Facebook
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Twitter)"
                mat-raised-button
                class="twitter-raised"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Twitter)">
          Twitter
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Github)"
                mat-raised-button
                class="github-raised"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Github)">
          GitHub
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Microsoft)"
                mat-raised-button
                class="microsoft-raised"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Microsoft)">
          Microsoft
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Yahoo)"
                mat-raised-button
                class="yahoo-raised"
                [ngClass.xs]="{'space-full-xs':true}"
                (click)="authProcess.signInWith(authProvider.Yahoo)">
          Yahoo
        </button>
      </div>

      <!--fab-->
      <div *ngSwitchCase="themes.FAB"
           class="buttons-raised"
           [fxLayout]="layout"
           [fxLayoutAlign]="layout == 'row' ? 'space-around center' : 'stretch'">
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Google)"
                mat-fab
                class="google-raised"
                (click)="authProcess.signInWith(authProvider.Google)">
          <mat-icon svgIcon="google"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Facebook)"
                mat-fab
                class="facebook-raised"
                (click)="authProcess.signInWith(authProvider.Facebook)">
          <mat-icon svgIcon="facebook"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Twitter)"
                mat-fab
                class="twitter-raised"
                (click)="authProcess.signInWith(authProvider.Twitter)">
          <mat-icon svgIcon="twitter"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Github)"
                mat-fab
                class="github-raised"
                (click)="authProcess.signInWith(authProvider.Github)">
          <mat-icon svgIcon="github"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Microsoft)"
                mat-fab
                class="microsoft"
                (click)="authProcess.signInWith(authProvider.Microsoft)">
          <mat-icon svgIcon="microsoft"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Yahoo)"
                mat-fab
                class="yahoo-raised"
                (click)="authProcess.signInWith(authProvider.Yahoo)">
          <mat-icon svgIcon="yahoo"></mat-icon>
        </button>
      </div>

      <!--mini-fab-->
      <div *ngSwitchCase="themes.MINI_FAB"
           class="buttons-raised"
           [fxLayout]="layout"
           fxLayoutAlign.xs="center center"
           [fxLayoutAlign]="layout == 'row' ? 'space-around center' : 'stretch'">
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Google)"
                mat-mini-fab
                class="google-raised"
                fxFlexAlign="center"
                (click)="authProcess.signInWith(authProvider.Google)">
          <mat-icon svgIcon="google"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Facebook)"
                mat-mini-fab
                class="facebook-raised"
                (click)="authProcess.signInWith(authProvider.Facebook)">
          <mat-icon svgIcon="facebook"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Twitter)"
                mat-mini-fab
                class="twitter-raised"
                (click)="authProcess.signInWith(authProvider.Twitter)">
          <mat-icon svgIcon="twitter" class="icon-white"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Github)"
                mat-mini-fab
                class="github-raised"
                (click)="authProcess.signInWith(authProvider.Github)">
          <mat-icon svgIcon="github"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Microsoft)"
                mat-mini-fab
                class="microsoft"
                (click)="authProcess.signInWith(authProvider.Microsoft)">
          <mat-icon svgIcon="microsoft"></mat-icon>
        </button>
        <button *ngIf="providers === authProvider.ALL || providers.includes(authProvider.Yahoo)"
                mat-mini-fab
                class="yahoo-raised"
                (click)="authProcess.signInWith(authProvider.Yahoo)">
          <mat-icon svgIcon="yahoo"></mat-icon>
        </button>
      </div>
    </div>
  `,
  styles: [`
    :host{display:block}:host .mat-icon{vertical-align:inherit}.space-full-xs{width:100%;margin:.4rem}.facebook-filled mat-icon{fill:#385899}.twitter-filled mat-icon{fill:#1da1f2}.buttons-raised button{color:#fff!important}.buttons-raised .google-raised{background-color:#db4437}.buttons-raised .facebook-raised{background-color:#385899}.buttons-raised .twitter-raised{background-color:#1da1f2}.buttons-raised .github-raised{background-color:#000}.buttons-raised .microsoft-raised{background-color:#00a4ef}.buttons-raised .yahoo-raised{background-color:#720e9e}.buttons-raised .phone-raised{background-color:#02bd7e}.buttons-classic button.google-classic{color:#db4437!important}.buttons-classic .facebook-classic{color:#385899!important}.buttons-classic .twitter-classic{color:#1da1f2!important}.buttons-classic .github-classic{color:#000!important}.buttons-classic .microsoft-classic{color:#00a4ef!important}.buttons-classic .yahoo-classic{color:#720e9e!important}.buttons-classic .phone-classic{color:#02bd7e}.icon-white{color:#fff}.icon-white mat-icon{fill:#fff}button.microsoft{background:#f8f9fa}
  `]
})
export class AuthProvidersComponent {

  @Input() theme: string; // theme: string = Theme.DEFAULT;
  @Input() layout: string = Layout.ROW;
  @Input() providers: string[] | string = AuthProvider.ALL; //  google, facebook, twitter, github, microsoft, yahoo

  @Output() onSuccess: any;
  @Output() onError: any;

  themes = Theme;
  authProvider = AuthProvider;

  constructor(public authProcess: AuthProcessService,
              private _iconRegistry: MatIconRegistry,
              private _sanitizer: DomSanitizer) {
    _iconRegistry
      .addSvgIcon('google',
        _sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/google.svg'))
      .addSvgIcon('google-colored',
        _sanitizer.bypassSecurityTrustResourceUrl('/assets/google.svg'))
      .addSvgIcon('facebook',
        _sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/facebook.svg'))
      .addSvgIcon('twitter',
        _sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/twitter.svg'))
      .addSvgIcon('github',
        _sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/github-circle.svg'))
      .addSvgIcon('microsoft',
        _sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/microsoft.svg'))
      .addSvgIcon('yahoo',
        _sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/yahoo.svg'))
      .addSvgIcon('phone',
        _sanitizer.bypassSecurityTrustResourceUrl('/assets/phone.svg'));

    this.onSuccess = authProcess.onSuccessEmitter;
    this.onError = authProcess.onErrorEmitter;
  }

}
